import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeSlot } from 'src/app/core/services/session-group.service';
import { EventDisplay } from 'src/app/public/reservation/presentationals/step-confirmation/step-confirmation.component';

@Component({
    selector: 'app-procedure-list',
    templateUrl: './procedure-list.component.html',
    styleUrls: ['./procedure-list.component.scss'],
    standalone: false
})

export class ProcedureListComponent implements OnInit, OnChanges {
  @Input() eventDisplay!: EventDisplay;

  message: string = '';
  additionalString: string | null | undefined;
  timeSlot!: TimeSlot;
  undefinedEnd: boolean = false;
  undefinedEndString: string | null | undefined;

  constructor(private readonly translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.timeSlot = this.eventDisplay.timeSlot;
    this.message = this.translateService.instant(this.eventDisplay.translationString);
    this.additionalString = this.eventDisplay.additionalString;
    this.undefinedEnd = this.eventDisplay.undefinedEnd;
    this.undefinedEndString = this.eventDisplay.undefinedEndString;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.timeSlot = this.eventDisplay.timeSlot;
    this.message = this.translateService.instant(this.eventDisplay.translationString);
    this.additionalString = this.eventDisplay.additionalString;
    this.undefinedEnd = this.eventDisplay.undefinedEnd;
    this.undefinedEndString = this.eventDisplay.undefinedEndString;
  }
}
